export const LogoMark = ({ size = 34 }) => (
  <img
    src="/logo.png"
    alt="Shelf Sense logo"
    style={{ height: size }}
    className="w-auto"
    data-testid="logo-mark"
  />
);

export const Logo = () => (
  <a
    href="#top"
    data-testid="nav-logo"
    className="flex items-center"
    onClick={(e) => {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: "smooth" });
    }}
  >
    <span className="inline-flex items-center rounded-xl bg-white px-3 py-1.5 shadow-lg shadow-purple-950/40">
      <img src="/logo.png" alt="Shelf Sense" className="h-7 w-auto" />
    </span>
  </a>
);
